// extracted by mini-css-extract-plugin
module.exports = {"slot":"ctaSlot_slot__jIf_a","outlinedCta":"ctaSlot_outlinedCta__bnla_"};